import { POSITION_SLOT_LIFECYCLE_LABELS } from 'domain/people/positionSlots/preview/constants';
import RenderCategory from 'domain/people/positionSlots/preview/shared/fields/RenderCategory';
import WorkerAndPfrCell from 'domain/people/positionSlots/preview/shared/fields/WorkerAndPfrCell';
import type { PreviewPositionSlotListItem } from 'domain/people/positionSlots/preview/types';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';
import type { ListTableColumn } from 'framework/ui/ui-builder';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { SimpleLinkField } from 'framework/ViewTypes';

export const getColumns = (
  getSingleEntityUrl: (id: string) => string,
): ListTableColumn<PreviewPositionSlotListItem>[] => [
  {
    id: 'specialization',
    label: 'Specialization',
    sortable: true,
    width: 180,
    render: positionSlot => (
      <SimpleLinkField to={getSingleEntityUrl(positionSlot.id)} value={positionSlot.specializationLabel} />
    ),
  },
  {
    id: 'technology',
    label: 'Technology',
    sortable: true,
    width: 150,
    render: positionSlot => positionSlot.technologyLabel || EMPTY_VALUE_INDICATOR,
  },
  {
    id: 'competencyLevel',
    label: 'Level',
    sortable: true,
    width: 110,
    render: positionSlot => positionSlot.competencyLevel || EMPTY_VALUE_INDICATOR,
  },
  {
    id: 'businessFunction',
    label: 'Business function',
    width: 180,
    render: positionSlot => positionSlot.businessFunctionLabel || EMPTY_VALUE_INDICATOR,
  },
  {
    id: 'workRateType',
    label: 'FTE',
    sortable: true,
    width: 110,
    render: positionSlot => EMPLOYEE_CONTRACT_ASSIGMENT_TYPES[positionSlot.workRateType],
  },
  {
    id: 'workerType',
    label: 'Category',
    sortable: true,
    width: 130,
    render: positionSlot => <RenderCategory positionSlot={positionSlot} />,
  },
  {
    id: 'offices',
    label: 'Location',
    sortable: true,
    width: 130,
    render: positionSlot => positionSlot.officesLabel || EMPTY_VALUE_INDICATOR,
  },
  {
    id: 'lifecycle',
    label: 'Status',
    sortable: true,
    width: 115,
    render: positionSlot => POSITION_SLOT_LIFECYCLE_LABELS[positionSlot.lifecycle] || positionSlot.lifecycle,
  },
  {
    id: 'worker',
    label: 'Worker / PFR',
    width: 220,
    render: positionSlot => <WorkerAndPfrCell positionSlot={positionSlot} />,
  },
];
